import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  drawElements = "DRAW_ELEMENTS",
  moveDiameter = "MOVE_DIAMETER",
  moveCircum = "MOVE_CIRCUMFERENCE_POINT",
  rotateCircle = "ROTATE_CIRCLE",
  setRefPoints = "SET_REF_POINTS",
  genRndmTriangle = "GENERATE_RANDOM_TRIANGLE",
  segmentMode = "SEGMENT_MODE"
}

export const eventBus = new EventEmitter();